import { Validators } from '../../../../../utils/validators';
import { FormModel } from '../../../../../components/Form';
export const AddEditVenueTypeForm = (strings: any, width = 3): FormModel[] => {
  const isFilter = width === 12;
  return [
    {
      label: strings.venueType_text_venueType,
      value: '',
      size: 'medium',
      autoFocus: true,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: width === 3 ? 'name' : 'venueTypeName',
      validators:
        width === 12
          ? []
          : [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 100 }],
      responsive: { xs: 12, sm: isFilter ? 12 : 6, md: width },
      required: width === 3,
    },
  ];
};
